import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'
import Loader from '../../../../../../components/Loader'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'

// Components
import User from '../../components/User'

// Actions
import { deactivateSearchByName, loadedData } from './actions'

class Start extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      first_candidate: {}
    }
  }

  getData() {
    let myComponent = this
    axios
      .get(
        `https://api.dsnapis.com/search/${
          this.props.customer_number
        }/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/54/agelow/35/oarhigh/10/oarlow/7/herprefage/0/herprefans/0/clrhigh/5/clrlow/1/education/-1/income/-1/offset/0/fetch/500`
      )
      .then(function(response) {
        //alert(JSON.stringify(response.data))
        if (Array.isArray(response.data)) {
          if (response.data.length < 40) {
            myComponent.getData()
          } else {
            myComponent.props.loadedData(response.data)

            let initial_user = response.data[0]
            let access_id = initial_user['access id']
            //myComponent.props.changeRoute(`/console/user/${access_id}`)
            myComponent.getPath(access_id, response.data)
          }
        } else {
          myComponent.getData()
        }
      })
  }

  componentDidMount() {
    if (this.props.rrd_data.length > 2) {
      let initial_user
      for (var i = 0; i < this.props.rrd_data.length; i++) {
        let user = this.props.rrd_data[i]
        const result_ommitted = this.props.items_ommitted.find(
          item => item.access_id === user['access id']
        )
        if (!result_ommitted) {
          initial_user = user
          break
        }
      }
      //  let initial_user = this.props.rrd_data[0];
      let access_id = initial_user['access id']

      //this.props.changeRoute(`/console/user/${access_id}`)
      this.getPath(access_id, this.props.rrd_data)
    } else {
      this.getData()
    }
  }

  getPath(initial_id, data) {
    if (
      window.location.href.includes(
        '/console/display/multi_folder_display/candidate_id/'
      )
    ) {
      var pathArray = window.location.pathname.split('/')
      let id = pathArray[pathArray.length - 1].replace(' ', '')

      if (id) {
        id = Number(id)

        let ids = []
        for (var i = 0; i < data.length; i++) {
          ids.push(data[i]['access id'])
        }

        let index = ids.indexOf(id)

        //alert(result);
        if (index != -1) {
          this.setState({
            first_candidate: data[index],
            loaded: true
          })
        } else {
          //alert("this executed");
          let initial_user
          for (var i = 0; i < this.props.rrd_data.length; i++) {
            let user = this.props.rrd_data[i]
            const result_ommitted = this.props.items_ommitted.find(
              item => item.access_id === user['access id']
            )
            if (!result_ommitted) {
              initial_user = user
              break
            }
          }
          let access_id = initial_user['access id']
          //alert(access_id)
          this.props.changeRoute(
            '/console/display/multi_folder_display/candidate_id/' + access_id
          )
        }
      } else {
        let initial_user
        for (var i = 0; i < this.props.rrd_data.length; i++) {
          let user = this.props.rrd_data[i]
          const result_ommitted = this.props.items_ommitted.find(
            item => item.access_id === user['access id']
          )
          if (!result_ommitted) {
            initial_user = user
            break
          }
        }
        let access_id = initial_user['access id']
        //alert(access_id)
        this.props.changeRoute(
          '/console/display/multi_folder_display/candidate_id/' + access_id
        )
      }
    } else {
      let initial_user
      for (var i = 0; i < this.props.rrd_data.length; i++) {
        let user = this.props.rrd_data[i]
        const result_ommitted = this.props.items_ommitted.find(
          item => item.access_id === user['access id']
        )
        if (!result_ommitted) {
          initial_user = user
          break
        }
      }
      let access_id = initial_user['access id']
      //alert(access_id)
      this.props.changeRoute(
        '/console/display/multi_folder_display/candidate_id/' + access_id
      )
    }
  }

  componentWillUnmount() {
    this.setState({
      loaded: false
    })
  }

  render() {
    const { classes, theme, location } = this.props
    const { first_candidate } = this.state

    if (this.state.loaded) {
      return (
        <div>
          <User data={first_candidate} />
        </div>
      )
    } else {
      // Lets get rrd data
      return (
        <div>
          <Loader />
        </div>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    rrd_data: state.rrd_data,
    items_ommitted: state.item_ommitted
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    deactivateSearchByName: () => dispatch(deactivateSearchByName()),
    loadedData: data => dispatch(loadedData(data)),
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(Start)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/MultifolderView/scenes/Start/index.js